import React from 'react';
import QuoteForm from '../components/home/QuoteForm';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const ContactPage: React.FC = () => {
  return (
    <main className="pt-20">
      <div className="bg-brand-navy py-24 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-black mb-6">Contact Us</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            Ready for a spotless home? Request a quote or get in touch with our team.
          </p>
        </div>
      </div>
      
      <div className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-24">
            <div className="p-10 bg-brand-gray-50 rounded-[2.5rem] border border-gray-100 space-y-6">
              <div className="w-14 h-14 bg-brand-blue/10 rounded-2xl flex items-center justify-center text-brand-blue">
                <Phone className="w-7 h-7" />
              </div>
              <h3 className="text-2xl font-bold text-brand-navy">Call Us</h3>
              <p className="text-brand-navy/60">Speak directly with our local team for immediate assistance.</p>
              <a href="tel:2018700452" className="text-xl font-black text-brand-blue block">(201) 870-0452</a>
            </div>
            
            <div className="p-10 bg-brand-gray-50 rounded-[2.5rem] border border-gray-100 space-y-6">
              <div className="w-14 h-14 bg-brand-blue/10 rounded-2xl flex items-center justify-center text-brand-blue">
                <Mail className="w-7 h-7" />
              </div>
              <h3 className="text-2xl font-bold text-brand-navy">Email Us</h3>
              <p className="text-brand-navy/60">Send us your questions or specific cleaning requirements.</p>
              <a href="mailto:chnjinfo@gmail.com" className="text-xl font-black text-brand-blue block">chnjinfo@gmail.com</a>
            </div>
            
            <div className="p-10 bg-brand-gray-50 rounded-[2.5rem] border border-gray-100 space-y-6">
              <div className="w-14 h-14 bg-brand-blue/10 rounded-2xl flex items-center justify-center text-brand-blue">
                <Clock className="w-7 h-7" />
              </div>
              <h3 className="text-2xl font-bold text-brand-navy">Hours</h3>
              <p className="text-brand-navy/60">We're available to clean and answer your calls during these times.</p>
              <div className="space-y-1">
                <p className="font-bold text-brand-navy">Mon - Fri: 8am - 6pm</p>
                <p className="font-bold text-brand-navy">Sat: 9am - 4pm</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <QuoteForm />
      
      <div className="py-24 bg-white">
        <div className="container mx-auto px-4 text-center">
          <div className="inline-flex items-center space-x-3 text-brand-navy font-bold text-lg mb-4">
            <MapPin className="w-6 h-6 text-brand-blue" />
            <span>Serving Jersey City & Hoboken, NJ</span>
          </div>
          <p className="text-brand-navy/40 font-bold uppercase tracking-widest text-xs">American Owned & Operated</p>
        </div>
      </div>
    </main>
  );
};

export default ContactPage;
